<template>
  <TransitionRoot
    appear
    as="template"
    :show="show"
  >
    <Dialog
      as="div"
      class="relative z-20"
      :role="'alertdialog'"
      v-bind="$attrs"
      @close="$emit('close')"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-blue/70" />
      </TransitionChild>
      <slot />
    </Dialog>
  </transitionroot>
</template>

<script setup lang="ts">
import { Dialog, TransitionChild, TransitionRoot } from '@headlessui/vue'
defineProps<{
  show: boolean
}>()
defineEmits(['close'])
</script>
